import { Vue } from 'vue'
import axios from 'axios'
import moment from 'moment'
import Config from '@/config'
import { AppState } from '@/state'
import CookieManager from '@/helpers/cookiemanager'
import { Enum } from '@/helpers/enum'

let apiInstance = null

export const API = {
  cancelToken: axios.CancelToken,
  searchCancelToken: null,
  useFreshHeaderKey: 'RZ-USE-FRESH',

  instance () {
    if (apiInstance == null) {
      const token = CookieManager.getItem('rzAccessToken')

      axios.defaults.params = {}
      axios.defaults.params['rz-app-key'] = Config.RZAppKey

      apiInstance = axios.create({
        baseURL: Config.APIPath,
        headers: {
          'RZ-ACCESS-TOKEN': token
        },
        transformRequest: (data, headers) => {
          if (!headers[API.useFreshHeaderKey]) {
            const urlParams = new URLSearchParams(window.location.search)
            const useFreshVal = urlParams.get('_usefresh')
            if (useFreshVal !== null) {
              headers[API.useFreshHeaderKey] = useFreshVal
              console.log('Added Use Fresh')
            }
          }
          // headers['content-type'] = 'application/json'
          return axios.defaults.transformRequest[0](data, headers)
        }
      })

      this.prepareAPI(apiInstance)
    }
    return apiInstance
  },

  getUseFreshHeader () {
    let params = {}
    params[API.useFreshHeaderKey] = 1
    return params
  },

  prepareAPI () {
    apiInstance.interceptors.response.use(response => response, (error) => {
      if (error.response && error.response.status === 403) {
        if (CookieManager.hasItem('rzAccessToken')) {
          CookieManager.removeItem('rzAccessToken')
          console.log('Relogin required')
          // window.location.href = window.location.href;
        }
      }
      return Promise.reject(error)
    })
  },

  cancelSearch () {
    if (API.searchCancelToken) {
      API.searchCancelToken.cancel()
      API.searchCancelToken = API.cancelToken.source()
    }
  },

  loginUser (token) {
    const expires = moment().add(23, 'hours')
    CookieManager.setItem('rzAccessToken', token, expires.toDate())
    AppState.updateUserLoggedIn(true)
  }

}

API.searchCancelToken = API.cancelToken.source()

export class LocalUserPref {
  static updateFetchMethod (newVal) {
    CookieManager.setItem('rzFetchMethod', newVal, Infinity, '/')
  }
  static fetchMethod (defaultVal) {
    const val = CookieManager.getItem('rzFetchMethod')
    if (val === null) {
      return defaultVal
    }
    return val
  }
}
